<template>
  <Modal v-model="model"  sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="insert_edit_dept">
      <div class="pop_top" style="min-height:300px">
        <div class="dept_edit_input"   v-if="btype=='3'">
          <div class="font_style_set"><span style="color: red;margin-right: 5px">*</span>访客openid:</div>
          <Input v-model="visitblackList" :maxlength="100"/>

        </div>
        <div class="dept_edit_input"   v-if="btype=='3'">
          <div class="font_style_set"><span style="color: red;margin-right: 5px">*</span>访客名称:</div>
          <Input v-model="visitorName" :maxlength="50"/>
        </div>
        <div  class="dept_edit_input" v-if="btype!='3'" >
          <div class="font_style_set" style="width:20%"> <span style="color: red;margin-right: 5px">*</span>IP方式:</div>
          <Select v-model="blackType" style="width: 250px" :disabled="editOrAdd">
            <Option v-for="(option, index) in blackTypeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>

        </div>
        <div class="dept_edit_input"   v-if="blackType=='1'&&btype!='3'">
          <div class="font_style_set" ><span style="color: red;margin-right: 5px">*</span>IP地址:</div>
          <Input v-model="blackList" placeholder="192.168.0.1" :maxlength="100"/>
        </div>
        <div class="dept_edit_input" v-if="blackType=='2'&&btype!='3'">
          <div class="font_style_set" style="width:17%"> <span style="color: red;margin-right: 5px">*</span>IP地址:</div>
          <Input v-model="blackListone" placeholder="192.168.0.1" :maxlength="100" style="width:35%"/><span style="margin-left:5px;margin-right:5px">-</span><el-Input v-model="blackListtwo" placeholder="2" :maxlength="100" style="width:35%"/>
        </div>
        <div class="dept_edit_input" style="margin-bottom:45px;margin-top:8px">
          <div class="font_style_set" >拉黑原因:</div>
          <Input v-model="blackReason" type="textarea" :autosize="{minRows: 3,maxRows: 100}" :maxlength="250"/>
        </div>
        <div class="dept_edit_input">
          <div class="font_style_set">备注:</div>
          <Input v-model="descr" type="textarea" :autosize="{minRows: 3,maxRows: 100}" :maxlength="250"/>
        </div>

      </div>
      <div class="btn_template">
        <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="save()">保存</Button>
      </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "AddipPop",
      mixins:[publicFunClass],
      props: {
        showAddipPop:Boolean,
        ipId:String,
        btype:String,
      },
      data(){
        return {
          model:false,
          title:'',
          journalType:'',
          menuId:'',
          editable:false,
          visitorName:'',
          blackType:"1",
          visitblackList:'',
          blackList:'',
          blackListone:'',
          blackListtwo:'',
          blackTypeList:[{'id':'1','name':'IP地址'},{'id':'2','name':'IP段'}],
          blackReason:'',
          descr:'',
          editOrAdd:false,
          editTypeAdd:'系统管理=>会话配置=>黑名单=>添加',
        }
      },
      methods:{
        cancel:function(){
          this.$emit("closeAddipPop",false);
        },
        save:function(){
          let that=this;
          let ipaddrees;
          if(this.btype=="3"){
            if(!this.visitblackList){
              that.$Modal.info({
                title:'提示',
                content:"访客openid不能为空"
              });
              return false;
            }
          }
          if(this.btype!="3"){
            if(!this.blackType){
              that.$Modal.info({
                title:'提示',
                content:"请选择IP方式"
              });
              return false;
            }
            if(this.blackType=="1"){//iP地址
                if(!this.blackList){
                    that.$Modal.info({
                        title:'提示',
                        content:"ip地址不能为空"
                    });
                    return false;
                }
            }
            if(this.blackType=="2"){//iP地址
                if(!this.blackListone || !this.blackListtwo){
                    that.$Modal.info({
                        title:'提示',
                        content:"请输入完整的IP段"
                    });
                    return false;
                }
            }
            let flag = false;
            let regex = /^\d+(\d\d\d)*[.\d]+$/g;
            if("1" == this.blackType){
              if (!regex.test(this.blackList)) {
                flag = true;
              }
            }else{
              if (!regex.test(this.blackListone)) {
                flag = true;
              }
              regex = /^[0-9]*$/g;
              if (!regex.test(this.blackListtwo)) {
                flag = true;
              }
            }
            if(flag){
              that.$Modal.info({
                title:'提示',
                content:"ip地址数据格式错误"
              });
              return false;
            }
          }
          if(this.btype=="3"){//访客
            this.blackType="3";
            ipaddrees=this.visitblackList;
          }
          if(this.blackType=="1"){
              ipaddrees=this.blackList
          }else if(this.blackType=="2"){
              ipaddrees=this.blackListone+'-'+this.blackListtwo
          }
          let param= {
            id:this.ipId,
            blackType:this.blackType,
            blackList:ipaddrees,
            descr:this.descr,
            blackReason:this.blackReason,
            visitorName:this.visitorName,
            journalType:this.editTypeAdd,
            menuId: "3_12-2-1",
          }
          this.$http.post("chatBlackList/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("操作成功");
            that.$emit("closeAddipPop",true);
          });
        },
        initSearch:function () {
             let that=this;
             let typelist;
             if(this.btype=="3"){//访客
               typelist="2";
             }else{//ip黑名单
               typelist="1";
             }
             let param={
                type:typelist,
                id:this.ipId,
                journalType: "系统管理=>会话配置=>黑名单=>查询",
                menuId: "3_12-2",
             };
             this.$http.post("chatBlackList/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              that.spinShow=false;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.contentList=res.data.obj.list.content;

              that.blackType=that.contentList[0].blackType;
              that.visitorName=that.contentList[0].visitorName;
              that.blackReason=that.contentList[0].blackReason;
              that.descr=that.contentList[0].descr;
              if(that.blackType=="1"){
                  that.blackList= that.contentList[0].blackList;
                  return false;
              }
              if(that.blackType=="2"){
                    that.blackListone = that.contentList[0].blackList.split("-")[0];
                    that.blackListtwo=that.contentList[0].blackList.split("-")[1];
                    return false;
              }
              if(that.blackType=="3"){
                  that.visitblackList=that.contentList[0].blackList;
                  return false;
              }

            });
        },
      },
      watch:{
        showAddipPop:function () {
          this.model=this.showAddipPop;
          this.editOrAdd=false;
          if(this.showAddipPop){
              if(!this.ipId){
                this.title='添加黑名单';
                this.editTypeAdd="系统管理=>会话配置=>黑名单=>添加";
                this.visitorName='';
                this.blackType='1';
                this.visitblackList='';
                this.blackList='';
                this.blackListone='';
                this.blackListtwo='';
                this.blackReason='';
                this.descr='';
              }else{
                this.editOrAdd=true,
                this.title='编辑黑名单';
                 this.editTypeAdd="系统管理=>会话配置=>黑名单=>编辑";
                this.initSearch();
              }

          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/AddipPop.vue